export enum FPinType {
  Regular = 1,
  Extended = 4,
  Viewed = 8,
}
